"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.slotTranslation = exports.SlotWrapper = void 0;
const React = __importStar(require("react"));
const SlotWrapper = ({ slotKey, slotContent, useSpan, useDisplayContents, }) => {
    const Wrapper = useSpan ? 'span' : 'div';
    return (React.createElement(Wrapper, { key: `wrapper--${slotKey}`, "data-wrapper-children": true, className: useDisplayContents ? 'use-display-contents' : '' }, slotContent));
};
exports.SlotWrapper = SlotWrapper;
const isDefaultSlotChild = (child) => child && (!child.props || !child.props.slot);
const isNamedSlotChild = (child) => child && child.props && child.props.slot;
const getChildrenBySlot = (children) => {
    const childrenBySlot = {
        default: [],
    };
    for (let i = 0; i < children.length; i++) {
        const child = children[i];
        if (isDefaultSlotChild(child)) {
            childrenBySlot.default.push(child);
        }
        if (isNamedSlotChild(child)) {
            const slot = child.props.slot;
            childrenBySlot[slot]
                ? childrenBySlot[slot].push(child)
                : (childrenBySlot[slot] = [child]);
        }
    }
    return childrenBySlot;
};
const getSlotsContent = (childrenBySlot) => {
    const slots = [];
    Object.keys(childrenBySlot).forEach((slotKey) => {
        if (slotKey === 'default') {
            slots.push(React.createElement(exports.SlotWrapper, { key: slotKey, slotKey: slotKey, slotContent: childrenBySlot[slotKey] }));
        }
        else {
            slots.push(...childrenBySlot[slotKey]);
        }
    });
    return slots;
};
const isUseDisplayContents = (children) => typeof children === 'object' &&
    children &&
    !Array.isArray(children) &&
    (!children.props.slot || children.props.slot === 'default') &&
    children.type !== React.Fragment;
const slotTranslation = (children) => {
    if (isUseDisplayContents(children)) {
        return [
            React.createElement(exports.SlotWrapper, { key: 'default', slotKey: 'default', slotContent: children, useDisplayContents: true }),
        ];
    }
    if (typeof children === 'string') {
        return [
            React.createElement(exports.SlotWrapper, { key: 'default', slotKey: 'default', slotContent: children, useSpan: true }),
        ];
    }
    if (children && Array.isArray(children)) {
        const childrenBySlot = getChildrenBySlot(children);
        return getSlotsContent(childrenBySlot);
    }
    return children;
};
exports.slotTranslation = slotTranslation;
//# sourceMappingURL=slot-translation.js.map